export const PARTICIPANT_SUBTITLE_SEPARATOR = ' \u2022 '